import { useState, useEffect } from 'react';
import supabase from '../supabase/supabase';

export const useNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data, error } = await supabase
      .from('notifications_1772945231000')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(10);

    if (!error) {
      setNotifications(data);
      setUnreadCount(data.filter(n => !n.is_read).length);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchNotifications();

    // Set up real-time subscription
    const channel = supabase
      .channel('schema-db-changes')
      .on('postgres_changes', 
        { event: 'INSERT', schema: 'public', table: 'notifications_1772945231000' }, 
        () => fetchNotifications()
      )
      .subscribe();

    return () => supabase.removeChannel(channel);
  }, []);

  const markAsRead = async (id) => {
    const { error } = await supabase
      .from('notifications_1772945231000')
      .update({ is_read: true })
      .eq('id', id);

    if (!error) {
      setNotifications(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    }
  };

  const scheduleReminder = async (assessmentTitle, date) => {
    const { data: { user } } = await supabase.auth.getUser();
    const { error } = await supabase
      .from('reminders_1772945231000')
      .insert([{ 
        user_id: user.id, 
        assessment_title: assessmentTitle, 
        remind_at: date 
      }]);
    
    return !error;
  };

  return { notifications, unreadCount, loading, markAsRead, scheduleReminder, refresh: fetchNotifications };
};